export const OverridesConfig = {
  columns: [
    { columnName: 'Date', field: 'date', header: 'Override Date', isDefault: true },
    { columnName: 'IsAllDay', field: 'isAllDay', header: 'Start and End Time', isDefault: true },
    { columnName: 'IsMonitored', field: 'isMonitored', header: 'Monitoring Hours', isDefault: true },
    { columnName: 'Type', field: 'type', header: 'Override Type', isDefault: true },
    { columnName: 'OverrideReason', field: 'overrideReasonTypeID', header: 'Override Reason', isDefault: true },
    { columnName: 'Requestor', field: 'requestor', header: 'Requestor', isDefault: true },
    { columnName: 'SiteCount', field: 'siteCount', header: 'No. of Sites', isDefault: true },
    { columnName: 'CreatedBy', field: 'createdBy', header: 'Created By', isDefault: true }  
  ],
  detailsColumns: [
    { columnName: 'CustomerName', field: 'customerName', header: 'Customer Name', isDefault: true },
    { columnName: 'SiteName', field: 'siteName', header: 'Site Name', isDefault: true },
    { columnName: 'NvrName', field: 'nvrName', header: 'NVR Name', isDefault: true },
    { columnName: 'State', field: 'state', header: 'State', isDefault: true },
    { columnName: 'Vertical', field: 'vertical', header: 'Vertical', isDefault: true },
    { columnName: 'DetectionGroup', field: 'detectionGroup', header: 'Detection Group', isDefault: true },
    { columnName: 'EscalationGroup', field: 'escalationGroup', header: 'Escalation Group', isDefault: true },
    { columnName: 'VMSType', field: 'vmsType', header: 'VMS Type', isDefault: true },
    { columnName: 'MonitoredBy', field: 'monitoredBy', header: 'Monitored By', isDefault: true },
    { columnName: 'MonitoringType', field: 'monitoringType', header: 'Monitoring Type', isDefault: true }
  ],
  pdfColumns: [
    { columnName: 'Date', field: 'date', header: 'Override Date', isDefault: true },
    { columnName: 'IsAllDay', field: 'allDay', header: 'Start and End Time', isDefault: true },
    { columnName: 'IsHoliday', field: 'isHoliday', header: 'Holiday', isDefault: true },    
    { columnName: 'IsMonitored', field: 'isMonitored', header: 'Monitoring Hours', isDefault: true },
    { columnName: 'Type', field: 'type', header: 'Override Type', isDefault: true },
    { columnName: 'Notes', field: 'notes', header: 'Notes', isDefault: true },
    { columnName: 'SiteCount', field: 'siteCount', header: 'No. of Sites', isDefault: true },
    { columnName: 'CreatedBy', field: 'createdBy', header: 'Created By', isDefault: true }  
  ],
}


